<template>
  <div>
    <form class="form-horizontal">
      <fieldset>
        <legend>{{ $t('preInvoice.academic') }}</legend>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('preInvoice.mainProgram')
            }}</label>
          <div class="col-md-8">
            <input type="text" class="form-control-plaintext" readonly :value="studentInfo
              ? studentInfo.academic_class.main_program.acp_name_foreign
              : ''
              " />
            <div class="validate" v-if="errors.has('acp_id')">
              {{ errors.first('acp_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">{{
            $t('preInvoice.subProgram')
            }}</label>
          <div class="col-md-8">
            <input type="text" class="form-control-plaintext" readonly :value="studentInfo
              ? studentInfo.academic_class.sub_program.acps_name_foreign
              : ''
              " />
            <div class="validate" v-if="errors.has('acps_id')">
              {{ errors.first('acps_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">
            Term/Semester
          </label>
          <div class="col-md-8">
            <a-select v-model="model.ac_term_id" style="width: 100%" :options="termOptions"
              @change="onTermChange"></a-select>
            <div class="validate" v-if="errors.has('ac_term_id')">
              {{ errors.first('ac_term_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">
            {{ $t('preInvoice.stopDateTerm') }}
          </label>
          <div class="col-md-8">
            <a-select v-model="model.term_stop" disabled></a-select>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4 required">
            {{
              this.termOptions != null
                ? this.termOptions[0]['ac_status_id'] == 1
                  ? 'Current Grade'
                  : 'New Grade'
                : 'Grade'
            }}
          </label>
          <div class="col-md-8">
            <div class="ts-flex ts-space-x-2 ts-items-center">
              <a-select v-model="model.grade_id" style="width: 100%" :options="gradeOptions"></a-select>
              <button :disabled="fetching" @click.prevent="fetchAllGrade"
                class="ts-whitespace-no-wrap ts-bg-blue-100 ts-text-blue-700 ts-rounded ts-px-3 ts-py-2 focus:ts-outline-none">
                <p v-if="!fetching">{{ $t('preInvoice.allGrade') }}</p>
                <i v-else class="fa fa-spin fa fa-spinner"></i>
              </button>
            </div>
            <div class="validate" v-if="errors.has('grade_id')">
              {{ errors.first('grade_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <label class="col-form-label col-md-4">{{
            $t('preInvoice.remark')
            }}</label>
          <div class="col-md-8">
            <textarea class="form-control" rows="3" v-model="model.remark"></textarea>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'preInvoiceAcademic',
  props: ['value', 'studentInfo', 'validate'],
  data() {
    return {
      model: {},
      termOptions: null,
      gradeOptions: [],
      errors: new Errors(),
      fetching: false
    }
  },
  computed: {
    statusText: () => (statusId) => {
      const statusList = {
        1: 'Currrent', 3: 'Next'
      }

      return statusList[statusId] || ''
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('preInvoice', ['preInvoiceFormView']),
    async fetchTerm() {
      if (this.studentInfo) {
        try {
          const response = await this.preInvoiceFormView({
            number_of_term_per_grade: this.studentInfo.academic_class.sub_program.number_of_term_per_grade,
            term_order: this.studentInfo.academic_class.academic_term.term_order,
            end_date_of_term: this.studentInfo.academic_class.academic_term.term_stop,
            grade_id: this.studentInfo.academic_class.grade.grade_id,
            ac_term_id: this.studentInfo.academic_class.academic_term.ac_term_id,
            student_id: this.studentInfo.student_id,
            ac_status_id: this.studentInfo.ac_status_id,
            acps_id: this.studentInfo.academic_class.acps_id,
            next_grade_id: this.studentInfo.academic_class.grade.next_grade_id,
            fnName: 'acTerm'
          });

          this.termOptions = response.acTerm.map(el => ({
            value: el.ac_term_id,
            label: this.statusText(el.ac_status_id) ? `${el.term_name} - ${this.statusText(el.ac_status_id)}` : el.term_name,
            ac_status_id: el.ac_status_id,
            ac_year_id: el.ac_year_id,
            term_stop: el.term_stop
          }));

          this.model.ac_status_id = this.termOptions.length
            ? this.termOptions[this.termOptions.length - 1].ac_status_id
            : '';

          this.model.term_stop = this.termOptions.length
            ? this.termOptions[this.termOptions.length - 1].term_stop
            : '';

          this.model.ac_term_id = this.termOptions.length
            ? this.termOptions[this.termOptions.length - 1].value
            : '';

          this.model.ac_year_id = this.termOptions.length
            ? this.termOptions[this.termOptions.length - 1].ac_year_id
            : '';

        } catch (error) {
          console.error('Error fetching term:', error);
          // Handle error appropriately
        }
      }
    },
    async fetchGrade() {
      if (this.studentInfo) {
        await this.preInvoiceFormView({
          number_of_term_per_grade: this.studentInfo.academic_class.sub_program
            .number_of_term_per_grade,
          term_order: this.studentInfo.academic_class.academic_term.term_order,
          end_date_of_term: this.studentInfo.academic_class.academic_term
            .term_stop,
          grade_id: this.studentInfo.academic_class.grade.grade_id,
          ac_term_id: this.studentInfo.academic_class.academic_term.ac_term_id,
          student_id: this.studentInfo.student_id,
          ac_status_id: this.studentInfo.ac_status_id,
          next_grade_id: this.studentInfo.academic_class.grade.next_grade_id,
          acps_id: this.studentInfo.academic_class.acps_id,
          fnName: 'grade'
        }).then(response => {
          this.gradeOptions = response.grade.map(el => ({
            value: el.grade_id,
            label: el.grade_name_foreign
          }))
        })
      }
    },
    async fetchAllGrade() {
      if (this.studentInfo) {
        this.fetching = true
        await this.preInvoiceFormView({
          acps_id: this.studentInfo.academic_class.acps_id,
          fnName: 'getAllGrade'
        }).then(response => {
          this.gradeOptions = response.getAllGrade.map(el => ({
            value: el.grade_id,
            label: el.grade_name_foreign
          }))
        })
          .finally(() => this.fetching = false)
      }
    },
    onTermChange(_, opt) {
      const acYearId = opt.data.props.ac_year_id
      this.model.ac_year_id = acYearId
      this.model.term_stop = opt.data.props.term_stop || ''
    }
  },
  watch: {
    studentInfo: function () {
      this.model.ac_term_id = null
      this.model.grade_id = null
      this.termOptions = null
      this.gradeOptions = null
      this.fetchTerm()
      this.fetchGrade()
    },
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
